export type MODAL_TYPE_T =
  | "ACCESS_DENIED"
  | "PLAN_LIMIT_REACHED"
  | "FEATURE_LIMITED_REACHED";

export const ACCESS_DENIED = "ACCESS_DENIED";
export const PLAN_LIMIT_REACHED = "PLAN_LIMIT_REACHED";
export const FEATURE_LIMITED_REACHED = "FEATURE_LIMITED_REACHED";
